import { createHandlerChainRunner, createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tCentro/Store/CustomHandlerCreator";

interface Parameter{
    isShippingFieldCompletedValue:boolean,
}

type HandlerType = CustomHandler<Parameter>;

export const CenSpcShippingFieldCompleted: HandlerType = props =>{

    props.dispatch({
        type:"Pages/OnePageCheckout/CenSpcShippingFieldCompleted",
        isShippingFieldCompletedValue:props.parameter.isShippingFieldCompletedValue,
    });
}

export const chain = [CenSpcShippingFieldCompleted];

const cenSpcShippingFieldCompleted = createHandlerChainRunner(chain, "CenSpcShippingFieldCompleted");
export default cenSpcShippingFieldCompleted;